<style lang="scss" scoped>
.field {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  color: #1f1f1f;
  position: relative;
  background: #FFF;
  border: 1px solid #e0e0e0;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  margin: 20px -30px;
  padding: 20px 30px;
}

#ms-report {
  min-height: calc(100vh - 63px);
}

.table-wrapper {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.status {
  padding: 4px 10px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  display: inline-block;
  
  &--draft {
    background-color: #e2e8f0;
    color: #475569;
  }
  &--submitted {
    background-color: #dbeafe;
    color: #1e40af;
  }
  &--review {
    background-color: #fef3c7;
    color: #92400e;
  }
  &--revised {
    background-color: #e0e7ff;
    color: #3730a3;
  }
  &--correction {
    background-color: #ffedd5;
    color: #c2410c;
  }
  &--rejected {
    background-color: #fee2e2;
    color: #991b1b;
  }
  &--approved {
    background-color: #dcfce7;
    color: #166534;
  }
  &--published {
    background-color: #ccfbf1;
    color: #115e59;
  }
}

.badge-jenis-stat {
  font-size: 9px !important;
  padding: 3px 6px;
  border-radius: 4px;
}

@media print {
  body * {
    visibility: hidden;
  }
  #printable-area, #printable-area * {
    visibility: visible;
  }
  #printable-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}
</style>

<template>
  <div>
    <div id="ms-report" class="content content--borderless">
      <div class="content__header">
        <div class="content__main-header">
          <div class="content__title">
            <div class="content__title__name">Report <span class="text-primary">Metadata Kegiatan Statistik</span></div>
            <div class="content__title__description">
              Gunakan beberapa pilihan filter untuk mengenerate laporan Metadata Kegiatan Statistik sesuai kebutuhan Anda.
            </div>
          </div>
        </div>
      </div>

      <div class="content__body">
        <div class="mt-4">
          <!-- Filter Panel -->
          <b-row class="align-items-end">
            <!-- Filter Submission Period (Tahun) -->
            <b-col cols="12" md="2" class="mb-3">
              <b-form-group label="Tahun Input" class="mb-0 font-weight-bold">
                <Treeselect
                  v-model="filters.submissionPeriod"
                  :options="options.submissionPeriod"
                  placeholder="Pilih Tahun"
                  :clearable="true"
                />
              </b-form-group>
            </b-col>

            <!-- Filter Status -->
            <b-col cols="12" md="3" class="mb-3">
              <b-form-group label="Status" class="mb-0 font-weight-bold">
                <Treeselect
                  v-model="filters.status"
                  :options="options.status"
                  placeholder="Pilih Status"
                  :clearable="true"
                />
              </b-form-group>
            </b-col>

            <!-- Filter Provinsi -->
            <b-col cols="12" md="2" class="mb-3">
              <b-form-group label="Provinsi" class="mb-0 font-weight-bold">
                <Treeselect
                  v-model="filters.provinsi"
                  :options="options.provinsi"
                  placeholder="Pilih Provinsi"
                  :clearable="!isProvinsiDisabled"
                  :disabled="isProvinsiDisabled"
                  @input="onProvinsiChange"
                />
              </b-form-group>
            </b-col>

            <!-- Filter Kabupaten/Kota (Dependent) -->
            <b-col cols="12" md="3" class="mb-3">
              <b-form-group label="Kabupaten/Kota" class="mb-0 font-weight-bold">
                <Treeselect
                  v-model="filters.kabupaten"
                  :options="options.kabupaten"
                  :disabled="isKabupatenDisabled || !filters.provinsi || isLoadingKabupaten"
                  :clearable="!isKabupatenDisabled"
                  :placeholder="isLoadingKabupaten ? 'Memuat...' : (filters.provinsi ? 'Pilih Kab/Kota' : 'Pilih Provinsi dahulu')"
                />
              </b-form-group>
            </b-col>

            <!-- Action Button -->
            <b-col cols="12" md="2" class="mb-3 text-right">
              <button type="button" class="btn btn-primary w-100" @click="fetchReportData(true)" :disabled="isLoading">
                <VueFeather v-if="!isLoading" type="play" size="14" class="mr-1"></VueFeather>
                <VueFeather v-else type="loader" animation="spin" size="14" class="mr-1"></VueFeather>
                Generate
              </button>
            </b-col>
          </b-row>

          <!-- Table Wrapper -->
          <div class="table-wrapper mt-3 mb-5">
            <div class="pagination-wrapper py-3 px-3 border-bottom d-flex align-items-center justify-content-between" style="background:#f8fafc">
              <div>
                <div class="text-16 font-weight-bold">
                  Preview Report <span class="text-primary">Metadata Kegiatan Statistik</span>
                </div>
                <div class="d-flex text-12 text-muted mt-1">
                  <div class="pr-3 border-right">
                    Total Data: <strong>{{ pagination.totalElements }}</strong>
                  </div>
                  <div class="pl-3">
                    Total Halaman: <strong>{{ pagination.totalPages }}</strong>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center">
                <div class="mr-2" style="width: 120px;">
                  <Treeselect
                    v-model="fileType"
                    :options="options.fileType"
                    :clearable="false"
                  />
                </div>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="exportReport"
                  :disabled="tableItems.length === 0 || isLoading || isExporting"
                >
                  <VueFeather v-if="!isExporting" type="download" size="14" class="mr-1"></VueFeather>
                  <VueFeather v-else type="loader" animation="spin" size="14" class="mr-1"></VueFeather>
                  {{ isExporting ? 'Exporting...' : 'Export' }}
                </button>
              </div>
            </div>

            <!-- TABLE PREVIEW FOR MSKEG -->
            <table class="table table-hover table-bordered mb-0">
              <thead class="thead-light">
                <tr>
                  <th class="text-center" style="width: 60px;">No.</th>
                  <th class="text-center" style="width: 120px;">ID</th>
                  <th class="text-center">Judul Kegiatan</th>
                  <th class="text-center" style="width: 130px;">Tahun Kegiatan</th>
                  <th class="text-center" style="width: 160px;">Status</th>
                  <th class="text-center">K/L/D/I</th>
                </tr>
              </thead>
              <tbody v-if="!isLoading && tableItems.length > 0">
                <tr v-for="(item, index) in tableItems" :key="index">
                  <td class="text-center">{{ (pagination.currentPage - 1) * pagination.pageSize + index + 1 }}</td>
                  <td class="text-center font-weight-bold">{{ getItemCode(item) }}</td>
                  <td class="text-left">
                    <span>{{ getJudulKegiatan(item) }}</span>
                    <span
                      v-if="getJenisStatistikLabel(item)"
                      :class="getJenisStatistikBadgeClass(item)"
                    >
                      {{ getJenisStatistikLabel(item) }}
                    </span>
                  </td>
                  <td class="text-center">{{ getTahunKegiatan(item) }}</td>
                  <td class="text-center">
                    <div>
                      <span :class="getStatusBadgeClass(item.status)">
                        {{ getStatusLabel(item.status) }}
                      </span>
                    </div>
                    <div class="mt-1 text-11 text-muted" style="font-size: 11px;">
                      <span>Variabel: <strong>{{ getTotalVariabel(item) }}</strong></span>
                      <span class="mx-1">•</span>
                      <span>Indikator: <strong>{{ getTotalIndikator(item) }}</strong></span>
                    </div>
                  </td>
                  <td class="text-left">{{ getProdusenDataName(item) }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center py-4 text-muted">
                    <div v-if="isLoading">
                      <VueFeather type="loader" animation="spin" size="20" class="mb-2"></VueFeather>
                      <div>Memuat data report dari server...</div>
                    </div>
                    <div v-else>
                      <VueFeather type="alert-circle" size="20" class="mb-2"></VueFeather>
                      <div>Data tidak tersedia. Silakan klik tombol <strong>Generate</strong> untuk memuat data.</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination Control -->
            <div class="p-3 bg-light border-top d-flex justify-content-between align-items-center" v-if="pagination.totalPages > 1">
              <div class="text-muted text-12">
                Menampilkan Halaman {{ pagination.currentPage }} dari {{ pagination.totalPages }}
              </div>
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.totalElements"
                :per-page="pagination.pageSize"
                align="right"
                size="sm"
                class="my-0"
                @change="onPageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hidden Printable Area for Full PDF Print -->
    <div id="printable-area" class="d-none d-print-block p-4">
      <h4 class="text-center mb-3">Report Metadata Kegiatan Statistik</h4>
      <table class="table table-bordered" style="width: 100%;">
        <thead>
          <tr>
            <th class="text-center" style="width: 50px;">No.</th>
            <th class="text-center" style="width: 100px;">ID</th>
            <th class="text-center">Judul Kegiatan</th>
            <th class="text-center" style="width: 120px;">Tahun Kegiatan</th>
            <th class="text-center" style="width: 130px;">Status</th>
            <th class="text-center">K/L/D/I</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in exportItems" :key="index">
            <td class="text-center">{{ index + 1 }}</td>
            <td class="text-center">{{ getItemCode(item) }}</td>
            <td class="text-left">
              <span>{{ getJudulKegiatan(item) }}</span>
              <span
                v-if="getJenisStatistikLabel(item)"
                :class="getJenisStatistikBadgeClass(item)"
              >
                {{ getJenisStatistikLabel(item) }}
              </span>
            </td>
            <td class="text-center">{{ getTahunKegiatan(item) }}</td>
            <td class="text-center">
              <div>{{ getStatusLabel(item.status) }}</div>
              <small class="text-muted" style="font-size: 10px; display: block;">
                Var: {{ getTotalVariabel(item) }} | Ind: {{ getTotalIndikator(item) }}
              </small>
            </td>
            <td class="text-left">{{ getProdusenDataName(item) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/main.scss";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Treeselect from '@riophae/vue-treeselect';
import VueFeather from 'vue-feather';
import XLSX from "xlsx";
import moment from "moment";
import store from "@/store";
import MsService from "@/services/MsService";
import MasterWilayahService from "@/services/ms/MasterWilayahService";
import WilayahService from "@/services/WilayahService";
import * as role from "@/views/ms/SdiRole.js";

export default {
  name: "ReportMetadata",
  components: {
    Treeselect,
    VueFeather
  },
  data() {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= 2018; y--) {
      years.push({ id: y.toString(), label: y.toString() });
    }

    return {
      isLoading: false,
      isLoadingKabupaten: false,
      isExporting: false,
      isProvinsiDisabled: false,
      isKabupatenDisabled: false,
      fileType: "EXCEL",
      exportItems: [],
      filters: {
        submissionPeriod: null,
        status: null,
        provinsi: null,
        kabupaten: null
      },
      options: {
        submissionPeriod: years,
        status: [
          { id: "DRAFT", label: "Draft" },
          { id: "SUBMITTED", label: "Submit" },
          { id: "UNDER_REVIEW", label: "Sedang Diperiksa" },
          { id: "REVISED", label: "Sudah Diperbaiki" },
          { id: "CORRECTION_REQUIRED", label: "Perlu Perbaikan" },
          { id: "REJECTED", label: "Ditolak" },
          { id: "APPROVED", label: "Disetujui" },
          { id: "PUBLISHED", label: "Publis" }
        ],
        provinsi: [],
        kabupaten: [],
        fileType: [
          { id: "EXCEL", label: "Excel" },
          { id: "PDF", label: "PDF" }
        ]
      },
      tableItems: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        totalPages: 0,
        totalElements: 0
      }
    };
  },
  async mounted() {
    this.initUserRoleAndFilters();
    await this.fetchProvinsiOptions();
    if (this.filters.provinsi) {
      await this.onProvinsiChange(this.filters.provinsi);
    }
    this.fetchReportData();
  },
  methods: {
    getUserWilayahInfo() {
      const user = store.getters["auth/user"] || JSON.parse(localStorage.getItem("user") || "{}");
      const appData = JSON.parse(localStorage.getItem("appData") || "{}");

      let roles = [];
      if (appData.current_role) {
        roles.push(appData.current_role);
      }
      if (user.role) {
        if (Array.isArray(user.role)) {
          roles.push(...user.role);
        } else if (typeof user.role === "string") {
          const parsed = user.role.replace(/[\][]/g, "").split(",").map(r => r.trim());
          roles.push(...parsed);
        }
      }
      if (user.roles && Array.isArray(user.roles)) {
        roles.push(...user.roles);
      }

      let provCode = null;
      let cityCode = null;

      if (user.organization) {
        if (user.organization.province) {
          provCode = user.organization.province.code || user.organization.province.id || user.organization.province;
        } else if (user.organization.province_code || user.organization.provinceCode) {
          provCode = user.organization.province_code || user.organization.provinceCode;
        }
        if (user.organization.city) {
          cityCode = user.organization.city.code || user.organization.city.id || user.organization.city;
        } else if (user.organization.city_code || user.organization.cityCode) {
          cityCode = user.organization.city_code || user.organization.cityCode;
        }
      }

      if (!provCode && user.sdiOrganization && user.sdiOrganization.details) {
        if (user.sdiOrganization.details.province) {
          provCode = user.sdiOrganization.details.province.code || user.sdiOrganization.details.province.id;
        }
        if (user.sdiOrganization.details.city) {
          cityCode = user.sdiOrganization.details.city.code || user.sdiOrganization.details.city.id;
        }
      }

      if (!provCode && user.province) {
        provCode = user.province.code || user.province.id || user.province;
      }
      if (!cityCode && user.city) {
        cityCode = user.city.code || user.city.id || user.city;
      }

      return {
        roles,
        provCode: provCode ? provCode.toString() : null,
        cityCode: cityCode ? cityCode.toString() : null
      };
    },

    initUserRoleAndFilters() {
      const info = this.getUserWilayahInfo();
      const rolesToCheck = info.roles;

      this.isProvinsiDisabled = false;
      this.isKabupatenDisabled = false;

      if (info.provCode && (role.isPembinaDataProvinsi(rolesToCheck) || role.isPembinaDataKabupatenKota(rolesToCheck)) && !role.isPembinaDataPusat(rolesToCheck) && !role.isSuperAdmin(rolesToCheck)) {
        this.filters.provinsi = info.provCode;
      }
      if (info.cityCode && role.isPembinaDataKabupatenKota(rolesToCheck) && !role.isPembinaDataPusat(rolesToCheck) && !role.isSuperAdmin(rolesToCheck)) {
        this.filters.kabupaten = info.cityCode;
      }
    },

    async fetchProvinsiOptions() {
      try {
        let resp = null;
        if (MasterWilayahService && typeof MasterWilayahService.getProvinsi === 'function') {
          resp = await MasterWilayahService.getProvinsi();
        } else {
          resp = await WilayahService.getProvinsi();
        }

        let provData = [];
        if (resp && resp.data) {
          provData = resp.data.data || resp.data.result || resp.data;
        }

        let mappedOptions = [];
        if (Array.isArray(provData)) {
          mappedOptions = provData.map(item => ({
            id: (item.kode_prov || item.kode_provinsi || item.code || item.id).toString(),
            label: item.nama_prov || item.nama_provinsi || item.name || item.nama
          }));
        }

        // Add PUSAT option with kode_provinsi '00'
        if (!mappedOptions.some(opt => opt.id === "00")) {
          mappedOptions.unshift({ id: "00", label: "PUSAT" });
        }

        const info = this.getUserWilayahInfo();
        const rolesToCheck = info.roles;

        // If user is Pembina Data Provinsi or Pembina Data KabKota (and not Pusat/SuperAdmin), restrict options.provinsi to ONLY their own province
        if (info.provCode && (role.isPembinaDataProvinsi(rolesToCheck) || role.isPembinaDataKabupatenKota(rolesToCheck)) && !role.isPembinaDataPusat(rolesToCheck) && !role.isSuperAdmin(rolesToCheck)) {
          const filtered = mappedOptions.filter(opt => opt.id === info.provCode);
          this.options.provinsi = filtered.length > 0 ? filtered : [{ id: info.provCode, label: `Provinsi (${info.provCode})` }];
          this.filters.provinsi = info.provCode;
        } else {
          this.options.provinsi = mappedOptions;
        }
      } catch (err) {
        console.error("Error fetching provinsi options:", err);
        this.options.provinsi = [{ id: "00", label: "PUSAT" }];
      }
    },

    async onProvinsiChange(provId) {
      const info = this.getUserWilayahInfo();
      const rolesToCheck = info.roles;
      const isKabKotaUser = role.isPembinaDataKabupatenKota(rolesToCheck) && !role.isPembinaDataPusat(rolesToCheck) && !role.isSuperAdmin(rolesToCheck);

      if (!isKabKotaUser) {
        this.filters.kabupaten = null;
      }
      this.options.kabupaten = [];
      if (!provId || provId === "00") return;

      this.isLoadingKabupaten = true;
      try {
        let resp = null;
        if (MasterWilayahService && typeof MasterWilayahService.getKabupatenKotaByProvinsi === 'function') {
          resp = await MasterWilayahService.getKabupatenKotaByProvinsi(provId);
        } else if (WilayahService && typeof WilayahService.getKabupatenKotaByKodeProvinsi === 'function') {
          resp = await WilayahService.getKabupatenKotaByKodeProvinsi(provId);
        } else if (WilayahService && typeof WilayahService.getKabupatenKotaByIdProvinsi === 'function') {
          resp = await WilayahService.getKabupatenKotaByIdProvinsi(provId);
        }

        let kabData = [];
        if (resp && resp.data) {
          kabData = resp.data.data || resp.data.result || resp.data;
        }

        if (Array.isArray(kabData)) {
          let mapped = kabData.map(item => ({
            id: (item.kode_kab || item.kode_kabupaten || item.code || item.id).toString(),
            label: item.nama_kab || item.nama_kabupaten || item.name || item.nama
          }));

          // If Pembina KabKota, restrict options.kabupaten to ONLY their own city
          if (isKabKotaUser && info.cityCode) {
            const filtered = mapped.filter(opt => opt.id === info.cityCode);
            mapped = filtered.length > 0 ? filtered : [{ id: info.cityCode, label: `Kabupaten/Kota (${info.cityCode})` }];
            this.filters.kabupaten = info.cityCode;
          }

          this.options.kabupaten = mapped;
        }
      } catch (err) {
        console.error("Error fetching kabupaten options:", err);
      } finally {
        this.isLoadingKabupaten = false;
      }
    },

    async fetchReportData(resetPage = false) {
      if (resetPage) {
        this.pagination.currentPage = 1;
      }
      this.isLoading = true;
      this.tableItems = [];

      const queryParts = [];
      queryParts.push(`page=${this.pagination.currentPage - 1}`);
      queryParts.push(`size=${this.pagination.pageSize}`);

      if (this.filters.submissionPeriod) {
        queryParts.push(`submissionPeriod=${this.filters.submissionPeriod}`);
      }
      if (this.filters.status) {
        queryParts.push(`status=${this.filters.status}`);
      }
      if (this.filters.provinsi) {
        queryParts.push(`produsenDataProvinceCode=${this.filters.provinsi}`);
      }
      if (this.filters.kabupaten) {
        queryParts.push(`produsenDataCityCode=${this.filters.kabupaten}`);
      } else if (this.filters.provinsi) {
        queryParts.push(`produsenDataCityCode=${this.filters.provinsi}00`);
      }

      const queryString = queryParts.join("&");

      try {
        const response = await MsService.getMsKegList(queryString);

        if (response && response.data) {
          const res = response.data;
          let items = [];
          let total = 0;
          let totalPages = 0;

          if (res.result && res.result[0]) {
            const pageObj = res.result[0];
            items = pageObj.content || pageObj.items || pageObj.data || [];
            total = pageObj.total_elements || pageObj.totalElements || items.length;
            totalPages = pageObj.total_pages || pageObj.totalPages || Math.ceil(total / this.pagination.pageSize);
          } else if (res.content) {
            items = res.content;
            total = res.total_elements || res.totalElements || items.length;
            totalPages = res.total_pages || res.totalPages || Math.ceil(total / this.pagination.pageSize);
          } else if (res.data) {
            items = Array.isArray(res.data) ? res.data : (res.data.content || []);
            total = res.total_elements || res.totalElements || items.length;
            totalPages = res.total_pages || res.totalPages || Math.ceil(total / this.pagination.pageSize);
          } else if (Array.isArray(res)) {
            items = res;
            total = res.length;
            totalPages = Math.ceil(total / this.pagination.pageSize);
          }

          this.tableItems = items;
          this.pagination.totalElements = total;
          this.pagination.totalPages = totalPages || 1;

          // Fetch details for each item using MsService.getMsKegById to get ms_var and ms_ind
          await Promise.all(
            items.map(async (item) => {
              const itemId = this.getItemCode(item);
              if (itemId && itemId !== '-') {
                try {
                  const detailResp = await MsService.getMsKegById(itemId);
                  if (detailResp && detailResp.data) {
                    const kegObj = (detailResp.data.result && detailResp.data.result[0]) ? detailResp.data.result[0] : detailResp.data;
                    if (kegObj) {
                      this.$set(item, 'ms_var', kegObj.ms_var || []);
                      this.$set(item, 'ms_ind', kegObj.ms_ind || []);
                      this.$set(item, 'total_ms_var', (kegObj.ms_var || []).length);
                      this.$set(item, 'total_ms_ind', (kegObj.ms_ind || []).length);
                    }
                  }
                } catch (err) {
                  console.error(`Error fetching MsKeg detail for ID ${itemId}:`, err);
                }
              }
            })
          );
        }
      } catch (error) {
        console.error("Error loading report metadata kegiatan:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async fetchAllReportData() {
      const queryParts = [];
      queryParts.push(`page=0`);
      queryParts.push(`size=${this.pagination.totalElements || 10000}`);

      if (this.filters.submissionPeriod) {
        queryParts.push(`submissionPeriod=${this.filters.submissionPeriod}`);
      }
      if (this.filters.status) {
        queryParts.push(`status=${this.filters.status}`);
      }
      if (this.filters.provinsi) {
        queryParts.push(`produsenDataProvinceCode=${this.filters.provinsi}`);
      }
      if (this.filters.kabupaten) {
        queryParts.push(`produsenDataCityCode=${this.filters.kabupaten}`);
      } else if (this.filters.provinsi) {
        queryParts.push(`produsenDataCityCode=${this.filters.provinsi}00`);
      }

      const queryString = queryParts.join("&");
      try {
        const response = await MsService.getMsKegList(queryString);
        let items = [];
        if (response && response.data) {
          const res = response.data;
          if (res.result && res.result[0]) {
            const pageObj = res.result[0];
            items = pageObj.content || pageObj.items || pageObj.data || [];
          } else if (res.content) {
            items = res.content;
          } else if (res.data) {
            items = Array.isArray(res.data) ? res.data : (res.data.content || []);
          } else if (Array.isArray(res)) {
            items = res;
          }
        }

        // Fetch detail for each export item to get ms_var and ms_ind
        if (items && items.length > 0) {
          await Promise.all(
            items.map(async (item) => {
              const itemId = this.getItemCode(item);
              if (itemId && itemId !== '-') {
                try {
                  const detailResp = await MsService.getMsKegById(itemId);
                  if (detailResp && detailResp.data) {
                    const kegObj = (detailResp.data.result && detailResp.data.result[0]) ? detailResp.data.result[0] : detailResp.data;
                    if (kegObj) {
                      item.ms_var = kegObj.ms_var || [];
                      item.ms_ind = kegObj.ms_ind || [];
                      item.total_ms_var = (kegObj.ms_var || []).length;
                      item.total_ms_ind = (kegObj.ms_ind || []).length;
                    }
                  }
                } catch (err) {
                  console.error(`Error fetching export MsKeg detail for ID ${itemId}:`, err);
                }
              }
            })
          );
        }

        return items;
      } catch (err) {
        console.error("Error fetching all report data for export:", err);
        return [];
      }
    },

    onPageChange(page) {
      this.pagination.currentPage = page;
      this.fetchReportData();
    },

    getItemCode(item) {
      if (!item) return '-';
      return item.id || item.code || item.id_kegiatan || '-';
    },

    getJudulKegiatan(item) {
      if (!item) return '-';
      return item.judul_kegiatan || item.judul || item.title || item.name || item.nama_kegiatan || '-';
    },

    getJenisStatistikLabel(item) {
      if (!item) return '';
      const raw = item.jenis_statistik || item.statistic_type || (item.blok_i ? item.blok_i.jenis_statistik : '') || '';
      const val = raw.toString().toUpperCase();
      if (val.includes('DASAR')) return 'Dasar';
      if (val.includes('SEKTORAL')) return 'Sektoral';
      if (val.includes('KHUSUS')) return 'Khusus';
      return '';
    },

    getJenisStatistikBadgeClass(item) {
      const label = this.getJenisStatistikLabel(item);
      if (label === 'Dasar') return 'badge badge-info badge-jenis-stat float-right ml-2';
      if (label === 'Sektoral') return 'badge badge-primary badge-jenis-stat float-right ml-2';
      if (label === 'Khusus') return 'badge badge-warning badge-jenis-stat float-right ml-2';
      return 'badge badge-secondary badge-jenis-stat float-right ml-2';
    },

    getTahunKegiatan(item) {
      if (!item) return '-';
      return item.tahun_kegiatan || item.submission_period || item.tahun || item.year || item.submissionPeriod || '-';
    },

    getProdusenDataName(item) {
      if (!item) return '-';
      return (
        item.produsen_data_name ||
        item.produsen_data ||
        item.organization_name ||
        (item.organization ? item.organization.name : null) ||
        '-'
      );
    },

    getStatusLabel(status) {
      if (!status) return '-';
      const found = this.options.status.find(s => s.id === status);
      return found ? found.label : status;
    },

    getStatusBadgeClass(status) {
      if (!status) return 'status';
      switch (status) {
        case 'DRAFT': return 'status status--draft';
        case 'SUBMITTED': return 'status status--submitted';
        case 'UNDER_REVIEW': return 'status status--review';
        case 'REVISED': return 'status status--revised';
        case 'CORRECTION_REQUIRED': return 'status status--correction';
        case 'REJECTED': return 'status status--rejected';
        case 'APPROVED': return 'status status--approved';
        case 'PUBLISHED': return 'status status--published';
        default: return 'status';
      }
    },

    getTotalVariabel(item) {
      if (!item) return 0;
      if (item.total_ms_var !== undefined && item.total_ms_var !== null) return item.total_ms_var;
      if (item.total_variabel !== undefined && item.total_variabel !== null) return item.total_variabel;
      if (item.total_variable !== undefined && item.total_variable !== null) return item.total_variable;
      if (item.totalVariabel !== undefined && item.totalVariabel !== null) return item.totalVariabel;
      if (item.total_var !== undefined && item.total_var !== null) return item.total_var;
      if (item.jumlah_variabel !== undefined && item.jumlah_variabel !== null) return item.jumlah_variabel;
      if (Array.isArray(item.ms_var)) return item.ms_var.length;
      if (Array.isArray(item.variabel)) return item.variabel.length;
      if (item.blok_iii && Array.isArray(item.blok_iii.variabel_yang_dikumpulkan)) return item.blok_iii.variabel_yang_dikumpulkan.length;
      if (item.blokIII && Array.isArray(item.blokIII.variabelYangDikumpulkan)) return item.blokIII.variabelYangDikumpulkan.length;
      return 0;
    },

    getTotalIndikator(item) {
      if (!item) return 0;
      if (item.total_ms_ind !== undefined && item.total_ms_ind !== null) return item.total_ms_ind;
      if (item.total_indikator !== undefined && item.total_indikator !== null) return item.total_indikator;
      if (item.total_indicator !== undefined && item.total_indicator !== null) return item.total_indicator;
      if (item.totalIndikator !== undefined && item.totalIndikator !== null) return item.totalIndikator;
      if (item.total_ind !== undefined && item.total_ind !== null) return item.total_ind;
      if (item.jumlah_indikator !== undefined && item.jumlah_indikator !== null) return item.jumlah_indikator;
      if (Array.isArray(item.ms_ind)) return item.ms_ind.length;
      if (Array.isArray(item.indikator)) return item.indikator.length;
      return 0;
    },

    async exportReport() {
      if (this.isExporting) return;
      this.isExporting = true;
      try {
        const allItems = await this.fetchAllReportData();
        const dataToExport = allItems.length > 0 ? allItems : this.tableItems;

        if (this.fileType === "EXCEL") {
          this.exportToExcel(dataToExport);
        } else if (this.fileType === "PDF") {
          this.exportItems = dataToExport;
          this.$nextTick(() => {
            window.print();
          });
        }
      } catch (err) {
        console.error("Export error:", err);
      } finally {
        this.isExporting = false;
      }
    },

    exportToExcel(items) {
      if (!items || items.length === 0) return;

      const exportData = items.map((item, index) => ({
        "No.": index + 1,
        "ID": this.getItemCode(item),
        "Judul Kegiatan": this.getJudulKegiatan(item),
        "Jenis Statistik": this.getJenisStatistikLabel(item) || "-",
        "Tahun Kegiatan": this.getTahunKegiatan(item),
        "Status": this.getStatusLabel(item.status),
        "Total Variabel": this.getTotalVariabel(item),
        "Total Indikator": this.getTotalIndikator(item),
        "K/L/D/I": this.getProdusenDataName(item)
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report Metadata Kegiatan");
      const fileName = `Report_Metadata_Kegiatan_Statistik_${moment().format('YYYYMMDD_HHmmss')}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    }
  }
};
</script>
